export interface IParkingPlace {
    id?: number;
    description: string | null;
    price?: number | null;
    quantity: number | null;
    type: number;
}

export enum ParkingPlacesType {
    UNDERGROUND = 1,
    GROUND = 2
}

export const getParkingPlacesType = (parkingPlacesType: ParkingPlacesType) => {
    switch (parkingPlacesType) {
        case ParkingPlacesType.UNDERGROUND:
            return "Miejsca postojowe podziemne";
        case ParkingPlacesType.GROUND:
            return "Miejsca postojowe naziemne";
        default:
            throw new Error("Unknown parking place type");
    }
};
export interface IParkingPlace {
    id?: number;
    description: string | null;
    price?: number | null;
    quantity: number | null;
    type: number;
}

export enum ParkingPlacesType {
    UNDERGROUND = 1,
    GROUND = 2
}

export const getParkingPlacesType = (parkingPlacesType: ParkingPlacesType) => {
    switch (parkingPlacesType) {
        case ParkingPlacesType.UNDERGROUND:
            return "Miejsca postojowe podziemne";
        case ParkingPlacesType.GROUND:
            return "Miejsca postojowe naziemne";
        default:
            throw new Error("Unknown parking place type");
    }
};
